if (!customElements.get('crypt-product-points')) {
  customElements.define(
    'crypt-product-points',
    class CryptProductPoints extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.rate = Number(this.dataset.rate || 5);
        this.valueElement = this.querySelector('[data-crypt-points-value]');
        this.update(Number(this.dataset.price || 0));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (String(data?.sectionId) !== String(this.sectionId) || !data?.variant) return;
            this.update(Number(data.variant.price || 0));
          });
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      update(priceInCents) {
        if (!this.valueElement || !Number.isFinite(priceInCents)) return;
        const points = Math.round((priceInCents * this.rate) / 100);
        this.valueElement.textContent = points.toLocaleString('en-GB');
      }
    }
  );
}
